import React from 'react'

import { P } from '@frame/ui-primitives/p'
import { Span } from '@frame/ui-primitives/span'

import { CLASSIFICATION_TYPE_LABELS } from '@documents/constants'
import { ClassificationResult } from '@documents/types'
import { DocumentCardDataAttribute } from '@frame/types'

function getClassificationCounts(allResults?: ClassificationResult[]) {
  const counts: Record<ClassificationResult, number> = {} as Record<ClassificationResult, number>
  allResults?.forEach((result) => {
    counts[result] = (counts[result] || 0) + 1
  })
  const sortedClassificationResultsByCount = Object.keys(counts).sort((a, b) => {
    const aCount = counts[a as ClassificationResult] || 0
    const bCount = counts[b as ClassificationResult] || 0
    if (aCount === bCount) {
      return 0
    } else if (aCount > bCount) {
      return -1
    } else {
      return 1
    }
  })

  return sortedClassificationResultsByCount
    .map((key) => {
      const result = key as ClassificationResult
      const label = CLASSIFICATION_TYPE_LABELS[result]
      const count = counts[result] || 0

      if (count === 1) {
        return label
      } else if (count > 1) {
        return `${count} ${label}s`
      } else {
        return undefined
      }
    })
    .filter((item) => item !== undefined)
}

export function Classification({ classifications }: { classifications?: ClassificationResult[] }) {
  const classificationCounts = getClassificationCounts(classifications)
  const numClassifications = classificationCounts.length

  let classificationString = CLASSIFICATION_TYPE_LABELS[ClassificationResult.UNKNOWN]

  if (numClassifications === 1) {
    classificationString = classificationCounts[0]
  } else if (numClassifications > 1) {
    classificationString = 'Multiple types detected'
  }

  return (
    <div data-cy={DocumentCardDataAttribute.CLASSIFICATION} className="flex">
      <P className="text-sm text-moss-500">
        Document type: <Span className="capitalize text-moss-700">{classificationString}</Span>
      </P>
    </div>
  )
}
